import React, {cloneElement, ReactNode, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router";
import {Search} from "../../../filtering";
import {oceanImportHblList, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import { DocumentType } from '../../../framework.core/DocumentType';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import Select from '../../../ui/Select';
import PrimaryButton from '../../../ui/PrimaryButton';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import MoveTypeDropDown from '../../../uiControls/MoveTypeDropDown';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import ApplicationContext from "../../../ApplicationContext";
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import {formatHblType} from './implementation/hblUtils';
import {JobNames} from "../../../framework.core/JobNames";
import {OiHblListItem, OihListType} from '../../../fms.data/models/OiHblListItem';
import * as XCol from "../../../framework.core/XExportColumn";
import IfmsModal from "../../../ui/IfmsModal";
import Menu, {IfmsMenuItem} from "../../../ui/menu/Menu";
import ListViewShortcutMenu from "../../common/ListViewShortcutMenu";
import fastStorage from '../../../fastStorage';
import HblBlStatusPopup from "./HblBlStatusPopup";
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import { FmsSubMenu } from "../../../constants/fmsSubMenu";
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from "../../../hooks/useReportViewer";
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, 
  ShipmentTypeRenderer, TrackEventNameRenderer, RQFilterRenderer, 
  LastEventRenderer,
  RQFilterEventRenderer,
  changeRQEvent,
  LclFclFilterRenderer,
  LclFclRenderer,
  OIShipmentTypeFilterRenderer} from "../../common/commonListRenderers";
import { formatDate, formatDateTime, nowDate } from "../../../dateUtils";
import useSetEditedId from "../../../hooks/useSetEditedId";
import { FmsSecTask } from "../../../fms.core/constants";
import { getFmsGlobal } from "../../../globals";
import BlackInverseButton from '../../../ui/BlackInverseButton';
import _ from "lodash";
import { SuntekSettings, SystemSettings } from "../../../ifmsTypes";
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from "../../../util";
import { useJournal } from "../../accounting/general/journal/JournalListView";
import useSystemSettings from "../../../hooks/useSystemSettings";
import HblReleasePopup from "./HblReleasePopup";
import CheckBoxIcon from "../../../ui/CheckBoxIcon";
import PrimaryInverseButton from "../../../ui/PrimaryInverseButton";
import RecogModal from "../../../ui/RecogModal";
import constants from "../../../constants";
import { Decimalformat, displayLastTrackingEvent, nullableCheckBoxValue } from "../../common/commonExportFormat";
import { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import UseAMSISfIcon from '../../../img/Isf_P_circle.svg';
import { SecType } from "../../../fms.enum";
import JobSwitchingMenuContext from "../../jobSwitchingMenuContext";
import useJobMenus from "../../../hooks/useJobMenus";
import SecondaryButton from "../../../ui/SecondaryButton";
import MultilineTextBox from "../../../ui/MultilineTextBox";
import { SQLField, SQLInfo, SQLType } from "../../../framework.core/data/SQLInfo";
import { ApiResult, InsertResultsWithData } from "../../../framework.core/data/ApiResult";
import taskReminderIconRed from '../../../img/pin_red.svg';
import { formatLclFcl } from "../../common/utils/formatUtils";
import cntrBlue from '../../../img/cntr-tracking-rq-12-blue.svg';
import { OiHbl } from "../../../fms.core/OiHbl";
import cntrGreen from '../../../img/cntr-tracking-rq-12-green.svg';
import { AmsHistoryArgs } from "../../../fms.report/args";
import SparkleIcon from '../../../img/ai-marker.svg';

async function DoSave(rowId: number, PopupInputValue: string|null, appContext: any) {
  const sqlList: SQLInfo[] = [];


    sqlList.push(new SQLInfo({
      tableName: "T_OIHMAIN",
      type: SQLType.Update,
      fields:[
          new SQLField({fieldName: "F_Remark", propertyName: "remark", value: PopupInputValue }),
      ],
     key: new SQLField({ fieldName: "F_Id", propertyName: "Id", value: rowId }),
    }));

  const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveSQLInfoList(sqlList);

  const editModelKey = `editOiMbl${rowId}-/oceanImport/hbl/edit`;
  const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
  if (keyMatch) {
    fastStorage[keyMatch].remark = PopupInputValue;
  }
  
}


function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  /*
  function onIndicatorClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(data[row.index].id);
  }
*/

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

 function OblDateRenderer({ row, cell }: any) {

  const {OblColClickFor} = useHblOperations();

   return <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} onClick={() => OblColClickFor('oblDate', row.original)}>
      {formatDate(cell.value)}
    </div>
}

function OblColRenderer({ row, cell }: any) {
  const {OblColClickFor} = useHblOperations();

  return <div  onClick={() => OblColClickFor('oblStat', row.original)} className="ifms-table-default">{cell.value}</div>;
}

function RlsDateRenderer({ row, cell }: any) {
  const {RlsColClickFor} = useHblOperations();

   return <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} onClick={() => RlsColClickFor(row, row.original)}>
      {formatDate(cell.value)}
    </div>
}

function RlsStatRenderer({ row, cell }: any) {
  const {RlsColClickFor} = useHblOperations();

  return <div onClick={() => RlsColClickFor(row, row.original)} className="ifms-table-default">{cell.value}</div>;
}

function RemarkRenderer({ row,cell }: any) {
  const {RemarkColClickFor} = useHblOperations();

  return <div onClick={() => RemarkColClickFor(row, row.original)} className="ifms-table-align-left">{cell.value}&nbsp;</div>;
}

function HblTypeFilterRenderer({value, onChange}:any) {
  return (
    <Select
      name='ifms-filter-hblType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'None', label: 'None'},
        { value: 'S', label: 'Standard'},
        { value: 'C', label: 'Co-Load'},
      ]}
    />
  );
}

function MoveTypeFilterRenderer({value, onChange}:any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}
    />
  );
}

// function CheckboxFilterRenderer({value, onChange}:any) {
//   const boolValue = typeof value === 'boolean' ? value : !!value;
//   return  <CheckBox label='Search for Checked Box' value={boolValue} onChange={onChange} />
// }

function AmsRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useAms = (l as any).useAms as boolean;

  if (useAms) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}><img height="13px" src={UseAMSISfIcon} alt="" data-toolip = '123' /></div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function IsfRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useIsf = (l as any).useIsf as boolean;

  if (useIsf) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}><img height="13px" src={UseAMSISfIcon} alt="" /></div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function InbondRenderer({ cell, row, data }: any) {
  const l = data[row.index];

  if (!!l.itNo) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`}>{l.itNo}</div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
    }
  }
  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

// function ChbRenderer({value, data, row}: any) {
//   let content: React.ReactNode = <></>;
//   if (value)
//     content = <img height="14px" src={chbBlue} alt="" />;
//   else
//     content = <img height="14px" src={chbGray} alt="" />;

//   return (
//     <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}>{content}</div>
//   );
// }

function ChbRenderer({ cell, row, data }: any) {
  const { viewReport } = useReportViewer();

  const l = data[row.index];
  const tooltip = l.chbRspCode === 'x' ? undefined : `${l.chbRspCode} - ${l.chbRspMsg}`;
  return <div id={`${cell.column.id}-${row.index}`} style={{cursor:l.amsHouseId === 0 ? 'default' :'pointer'}} onClick={() => openHouseHistoryReport()} className="ifms-table-default" data-tooltip={tooltip}>{cell.value}</div>;

  async function openHouseHistoryReport() {
    if (!l || l.amsHouseId <= 0) return;
    const title = "Ams House BL # " + l.hblNo;
    const args = new AmsHistoryArgs({
      docType: DocumentType.AmsHistory,
      formCaption: title,
      subject: title,

      dataCompanyID: 0,
      houseID: Number(l.amsHouseId),
      amsMode: 'AMS'
    })
    viewReport(args, "", true);
  }
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function ContainerRenderer({ cell, value, data, row }: any) {
  const l = data[row.index];
  return (
    <div className="ifms-table-default" id={`oih-container-${cell.column.id}`} data-tooltip={l.fullCntrNo}>{value}</div>
  );
}


function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedHblOperations();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}
      {isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}


function HblNoRenderer({value, data, row, cell}: any){
    
  const isAiAgent = data[row.index].u1ID.toUpperCase() === '@AIAGENT';

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left"
          style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}
    >
      {value}
      {isAiAgent ? <img src={SparkleIcon} /> : <></>}
    </div>
}


function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function HblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as OiHblListItem;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  const { deleteHbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, setSavedEntityOim } = useSelectedHblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const {switchJournal} = useJournal();
  
  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityOim(selectedElement.oiMblId.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/hbl/add');
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OIHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  function onPopupCompClick(selectedPopupMenuItem: ActionButtonItem) {
    if(selectedPopupMenuItem.label === 'Release Order/Turnover'){
      // if(fmsGlobal.NoRelease){
      //   showGlobalOkDialog('Contact Manager');
      //   return false;
      // }
    }

    return true;
  }


  function switchJournalSBL(){
    // Single B/L 이면 Master의 Journal을 표시하도록 수정
    return selectedElement.sbl ?  switchJournal(JobNames.OIMbl, selectedElement.oiMblId, "", null, selectedElement.refNo) : switchJournal(JobNames.OIHbl, selectedElement.id, "", null, selectedElement.hblNo)
  }

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIHbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId?.startsWith('@');
  
  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
    
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);

  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/mbl/oceanImport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/oceanImport/mbl/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
    ? `/oceanImport/hbl/add?mblRefId=${jobListContext.f6Query}`
    : '/oceanImport/hbl/add';

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
       <div className='ifms-common-vertical-gap-8'>
          {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
          <UniqueLinkButton  newStyle name='oih-list-add-button' display="primary" link={newUrl} uniqueLinkPrefixQuery="/oceanImport/hbl/add" disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
          <EditIconButton2 name='oih-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
          <ViewIconButton2 name='oih-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
          <DeleteIconButton2 name='oih-list-delete-button' disabled={!canBeDeleted} onClick={deleteHbl} useText />
        </div>
      <div className='ifms-common-vertical-gap-8'>
          {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
                <PrimaryButton name='oih-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
          {!noBillingsShow && <BillingsIconButton name='oih-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
          {!noProfitShow && <PrimaryButton name='oih-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
          <DeleteHistoryIconButton onClick={moveToDeleteHistoryReport} useText />
          <RecogHistoryIconButton onClick={moveToRecogHistoryReport} useText />
          {!checkSecJournal && <JournalIconButton onClick={()=> switchJournalSBL()} useText/>}
        </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent && onPopupCompClick(selectedPopupMenuItem) ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.oiMblId} mTbName={"T_OIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function HblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OiHblListItem>) {
  return data.map(d => ({
    ...d,
    //hblType: formatHblType(d.hblType),
    bizMode: formatHblType(d.bizMode),
    hasCLimit: d.hasCLimit === 'Y', // Backend returns Y/N instead of bool
  }));
}

function useHblOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  const appContext = useContext(ApplicationContext);
  const systemSettings = useSystemSettings();
  const fmsGlobal = getFmsGlobal();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  function switchToMblFor(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport',
      //'mblNo', 'Mbl No', hbl.mblNo ?? '', 'updated', false
      'id', 'Ref. #', hbl.oiMblId, 'u2Date', false, true, null, 'refNo', hbl.refNo, false,true);
    openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
  }

  function switchToContainerFor(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/OICN/oceanImport', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'oiMblId', 'Ref. #', hbl.oiMblId, '', false, true, null, 'refNo', hbl.refNo, false, true);
    openNewPage(history, `/common/joblistview/OICN/oceanImport`, NavigationType.newPage);
  }


  function switchToAmsFor(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSH/oceanImport', 
    //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
    // 'refNo', '', mbl.refNo ?? '', 'update', false);
    'amsLinkId', 'AMS ID', hbl.amsLinkId, '', false, true, null,null,null, false, true);
    openNewPage(history, `/common/joblistview/AMSH/oceanImport`, NavigationType.newPage);
  }

  async function OblColClickFor(fieldName: string, data: any) {
    //fieldName: OblStat, OblDate

    // if (fmsGlobal.NoRelease) {
    //   showGlobalOkDialog('Contact Manager!');
    //   return;
    // }

    let nRet = 0;

    if (data.oblStat === 'N' && fieldName === 'oblStat') {
      switch (fmsGlobal.AcmeID3) {
        case 'OEC':
        case 'CCL':
          // chkOblForm
          break;
        default:
          const confirm = await showGlobalYesNoDialog(
            <div>
              <h3>Original B/L Received ?</h3>
            </div>
          ,false, 0, true);

          if (confirm) {
            nRet = 1;
          } else {
            nRet = 0;
          }
          break;
      }

      if (nRet !== 0) {
        let now = nowDate();
        const apiResult = await appContext.api.setOblCol(data.id, nRet.toString(), now);
        if (apiResult && apiResult.success) {
          data.oblStat = 'Origin';
          data.oblDate = now;
        }
      }
    }

    if (data.oblStat !== 'N') {
      if (data.expRls === true) {
        showGlobalOkDialog('EXPRESS RELEASE');
      } else {
        let tRet = '';
        if (data.oblCol === '1') tRet = ' at Origin';
        else if (data.oblCol === '2') tRet = ' at Dest.';
        if (["OEC", "CCL"].indexOf(fmsGlobal.AcmeID3 ?? '') > -1) tRet = '';

        showGlobalOkDialog(`O B/L RECEIVED ON ${formatDate(data.oblDate, systemSettings.dateFormat ?? '')}${tRet}`);
      }
    }
  }
  
  async function RlsColClickFor(row: any, data:any) {
    // if (fmsGlobal.NoRelease) {
    //   showGlobalOkDialog('Contact Manager!');
    //   return;
    // }

    if (fmsGlobal.CashierRelease && data.rlsStat !== 'y') {
      jobListContext.setRowExtrasId(data.id);
    } else if (data.rlsStat === 'Y') {
      showGlobalOkDialog(`Released on ${formatDate(data.rlsDate, systemSettings.dateFormat ?? '')} by ${data.rlsBy??''}`);
    } else {
      const doRelease = await showGlobalYesNoDialog(
        <div>
          <h3>Do you want to release?</h3>
        </div>,false, 0, true);

      if (doRelease) {
        await appContext.api.releaseNow({hblId: data.id, hblNo: data.hblNo});
      }
      
    }
  }

  async function switchToAcctInfo(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    if (hbl.sbl) // Single BL
      openNewPage(history, `/accounting/Acct/${JobNames.OIMbl}/${hbl.oiMblId}`, NavigationType.newPage);
    else
      openNewPage(history, `/accounting/Acct/${JobNames.OIHbl}/${hbl.id}`, NavigationType.newPage);
  }

  async function RemarkColClickFor(row: any, data:any) {
      jobListContext.setRowExtrasId(data.id);
    
  }

  return { switchToMblFor, switchToContainerFor, switchToAmsFor, OblColClickFor, RlsColClickFor, switchToAcctInfo, RemarkColClickFor };
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const { switchToMblFor, switchToContainerFor, switchToAmsFor } = useHblOperations();

  const selectedElement = jobListContext.selectedElement as OiHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const setSavedEntityOim = useSetEditedId([JobNames.OIMbl]);

  async function create() {
    const createUrl = '/oceanImport/hbl/add';

    if (jobListContext.hasOpenedScreenStartingWithUrl(createUrl)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/mbl/oceanImport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/oceanImport/mbl/edit/' + jobListContext.f6Query;

    const newUrl = openedByF6 || openedByMaster
      ? `/oceanImport/hbl/add?mblRefId=${jobListContext.f6Query}`
      : createUrl;

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close HBL first', false, null, "warning");
    //   return;
    // }

    let id = selectedElement.id;
    let jobName = JobNames.OIHbl;
    let editUrl = `/oceanImport/hbl/edit/${id}`;
    let viewUrl = `/oceanImport/hbl/view/${id}`;

    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      jobName = JobNames.OIMbl;
      editUrl = `/oceanImport/mbl/edit/${id}`;
      viewUrl = `/oceanImport/mbl/view/${id}`;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/${jobName}/${id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/${jobName}/${id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.', false, null, 'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(jobName, { id, pimsLinkId: selectedElement.pimsLinkId, sbl: selectedElement.sbl });
      
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        // const editUrl = `/oceanImport/hbl/edit/${selectedElement.id}`;
        // const viewUrl = `/oceanImport/hbl/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }

        jobListContext.reloadData();
        setSavedEntityOim(selectedElement.oiMblId.toString(), false, true);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null, 'warning');
      }
    }
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    var id = selectedElement.id;
    let jobName = JobNames.OIHbl;
    const tabIndex = 2;
    let baseUrl = '/oceanImport/hbl';
    let editBaseUrl = `${baseUrl}/edit/${id}`;
    let viewBaseUrl = `${baseUrl}/view/${id}`;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      jobName = JobNames.OIMbl;
      baseUrl = '/oceanImport/mbl';
      editBaseUrl = `${baseUrl}/edit/${id}`;
      viewBaseUrl = `${baseUrl}/view/${id}`;
    } 

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${jobName}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    var id = selectedElement.id;
    let jobName = JobNames.OIHbl;
    let tabIndex = 4;
    let baseUrl = '/oceanImport/hbl';
    let editBaseUrl = `${baseUrl}/edit/${id}`;
    let viewBaseUrl = `${baseUrl}/view/${id}`;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      jobName = JobNames.OIMbl;
      tabIndex = 4;
      baseUrl = '/oceanImport/mbl';
      editBaseUrl = `${baseUrl}/edit/${id}`;
      viewBaseUrl = `${baseUrl}/view/${id}`;
    } 

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${jobName}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
    let id = selectedElement.id;
    let jobName = JobNames.OIHbl;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      jobName = JobNames.OIMbl;
    } 

    const listSec = findSecurityTask(appContext, FmsSecTask.OIDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const viewUrl = `/common/deleteHistory?jobname=${jobName}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    let id = selectedElement.id;
    let jobName = JobNames.OIHbl;

    // Single BL
    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      jobName = JobNames.OIMbl;
    } 

    const listSec = findSecurityTask(appContext, FmsSecTask.OIRecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const viewUrl = `/common/recogHistory?jobname=${jobName}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let editUrl = `/oceanImport/hbl/edit/${id}`;
    let viewUrl = `/oceanImport/hbl/view/${id}`;

    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      editUrl = `/oceanImport/mbl/edit/${id}`;
      viewUrl = `/oceanImport/mbl/view/${id}`;
    }

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanImport/hbl/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);

  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let editUrl = `/oceanImport/hbl/edit/${id}`;
    let viewUrl = `/oceanImport/hbl/view/${id}`;
    let listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIHbl, selectedElement.branch);

    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      editUrl = `/oceanImport/mbl/edit/${id}`;
      viewUrl = `/oceanImport/mbl/view/${id}`;
      listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement.branch);
    }
    
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    let id = selectedElement.id;
    let copyUrl = '/oceanImport/hbl/add';

    if (selectedElement.sbl) {
      id = selectedElement.oiMblId;
      copyUrl = '/oceanImport/mbl/add';
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(copyUrl)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, `${copyUrl}?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OiHblListItem;
    switchToMblFor(selectedElement);
  }

  function switchToContainer() {
    const selectedElement = jobListContext.selectedElement as OiHblListItem;
    switchToContainerFor(selectedElement);
  }

  function switchToAms() {
    const selectedElement = jobListContext.selectedElement as OiHblListItem;
    switchToAmsFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }


  function openDocServer(hbl:OiHblListItem|null){
    if (!hbl) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }


  return { create, deleteHbl, edit, view, copy, 
    switchToMbl, switchToContainer, switchToAms, recognize, 
    viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, viewProfit, setSavedEntityOim, openDocServer };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMbl, switchToContainer, switchToAms, recognize, viewBillings, viewProfit } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiHblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const userID = appContext.user ? appContext.user.id ?? '' : '';
  const fmsGlobal = getFmsGlobal();
  const setSavedEntityAfterClose = useSetEditedId([JobNames.OIMbl]);

  function openContainerTracking() {
    let blNo = `hbl=${selectedElement.hblNo}`;
    if (selectedElement.sbl) {
      blNo = `mbl=${selectedElement.mblNo}`;
    }

    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&${blNo}`);
  }

  function openBLStatus() {
    if (jobListContext.rowExtrasId) {
      jobListContext.setmodalShow("openBLStatus");
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
    jobListContext.setmodalShow("openBLStatus");
  }
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIHbl, selectedElement?.branch);
  const containerSec = findSecurityTask(appContext, FmsSecTask.OIContainer);
  const amsSec = findSecurityTask(appContext, FmsSecTask.AMSHouse);
  const mblSec = findSecurityTask(appContext, FmsSecTask.OIMbl);

  async function processFileLock() {
    if (selectedElement.sbl) {
      processFileLockAsMblFromHbl();
    } else {
      const fileLockResult = await appContext.api.opClose(JobNames.OIHbl, selectedElement.id, !selectedElement.isClosed);
      if (!!fileLockResult) {
        await showGlobalOkDialog(fileLockResult, false,null,'warning');
        return;
      }

      const hasOpened =
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/edit/${selectedElement.id}`) ||
        jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/view/${selectedElement.id}`)

      if (selectedElement.isClosed && hasOpened) {
        const editModelKey = `editOiHbl${selectedElement.id}-/oceanImport/hbl/edit`;
        const viewModelKey = `viewOiHbl${selectedElement.id}-/oceanImport/hbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 0;
          fastStorage[keyMatch].isClosed = false;
          fastStorage[keyMatch].closedBy = '';
          fastStorage[keyMatch].closeDate = null;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 0;
          fastStorage[viewKeyMatch].isClosed = false;
          fastStorage[viewKeyMatch].closedBy = '';
          fastStorage[viewKeyMatch].closeDate = null;
        }
      } else if (!selectedElement.isClosed && hasOpened) {
        const editModelKey = `editOiHbl${selectedElement.id}-/oceanImport/hbl/edit`;
        const viewModelKey = `viewOiHbl${selectedElement.id}-/oceanImport/hbl/view`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const closeDate = await appContext.api.getFieldValueDate({
          id: selectedElement.id,
          tableName: 'T_OIHMAIN',
          fieldName: 'F_CloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 1;
          fastStorage[keyMatch].isClosed = true;
          fastStorage[keyMatch].closedBy = userID;
          fastStorage[keyMatch].closeDate = closeDate;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 1;
          fastStorage[viewKeyMatch].isClosed = true;
          fastStorage[viewKeyMatch].closedBy = userID;
          fastStorage[viewKeyMatch].closeDate = closeDate;
        }
      }

      jobListContext.reloadData();
    }
  }

  async function processFileLockAsMblFromHbl() {
    const mblId = selectedElement.oiMblId;

    const fileLockResult = await appContext.api.opClose(
      JobNames.OIMbl,
      mblId,
      !selectedElement.isClosed
    );

    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null, 'warning');
      return;
    }

    const hasOpenedMbl =
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${mblId}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/view/${mblId}`);

    const editModelKey = `editOiMbl${mblId}-/oceanImport/mbl/edit`;
    const viewModelKey = `viewOiMbl${mblId}-/oceanImport/mbl/view`;

    const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
    const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

    if (hasOpenedMbl) {
      if (selectedElement.isClosed) {
        // Open
        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 0;
          fastStorage[keyMatch].isClosed = false;
          fastStorage[keyMatch].closedBy = '';
          fastStorage[keyMatch].closeDate = null;

          fastStorage[keyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 0;
          });
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 0;
          fastStorage[viewKeyMatch].isClosed = false;
          fastStorage[viewKeyMatch].closedBy = '';
          fastStorage[viewKeyMatch].closeDate = null;

          fastStorage[viewKeyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      } else {
        // Close
        const closeDate = await appContext.api.getFieldValueDate({
          id: mblId,
          tableName: 'T_OIMMAIN',
          fieldName: 'F_CloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].fileClosed = 1;
          fastStorage[keyMatch].isClosed = true;
          fastStorage[keyMatch].closedBy = userID;
          fastStorage[keyMatch].closeDate = closeDate;

          fastStorage[keyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 1;
          });
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].fileClosed = 1;
          fastStorage[viewKeyMatch].isClosed = true;
          fastStorage[viewKeyMatch].closedBy = userID;
          fastStorage[viewKeyMatch].closeDate = closeDate;

          fastStorage[viewKeyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }
    }

    jobListContext.reloadData();
    setSavedEntityAfterClose('0', false, false, true);
  }

  async function processAccountLock() {
    if (selectedElement.sbl) {
      processAccountLockAsMblFromHbl();
    } else {
      const accountLockResult = await appContext.api.accountClose(JobNames.OIHbl, selectedElement.id, !selectedElement.isAccountClosed);
      if (!!accountLockResult) {
        await showGlobalOkDialog(accountLockResult, false,null,'warning');
        return;
      }

      const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/view/${selectedElement.id}`)
      
      if (selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editOiHbl${selectedElement.id}-/oceanImport/hbl/edit`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewModelKey = `viewOiHbl${selectedElement.id}-/oceanImport/hbl/view`;
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
          fastStorage[keyMatch].isAccountClosed = false;
          fastStorage[keyMatch].accountClosedBy = '';
          fastStorage[keyMatch].accountCloseDate = null;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 0;
          fastStorage[viewKeyMatch].isAccountClosed = false;
          fastStorage[viewKeyMatch].accountClosedBy = '';
          fastStorage[viewKeyMatch].accountCloseDate = null;
        }
      } else if (!selectedElement.isAccountClosed && hasOpened) {
        const editModelKey = `editOiHbl${selectedElement.id}-/oceanImport/hbl/edit`;
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        const viewModelKey = `viewOiHbl${selectedElement.id}-/oceanImport/hbl/view`;
        const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

        const accountCloseDate = await appContext.api.getFieldValueDate({
          id: selectedElement.id,
          tableName: 'T_OIHMAIN',
          fieldName: 'F_AcctCloseDate'
        });


        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 1;
          fastStorage[keyMatch].isAccountClosed = true;
          fastStorage[keyMatch].accountClosedBy = userID;
          fastStorage[keyMatch].accountCloseDate = accountCloseDate;
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 1;
          fastStorage[viewKeyMatch].isAccountClosed = true;
          fastStorage[viewKeyMatch].accountClosedBy = userID;
          fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
        }
      }

      jobListContext.reloadData();
    }
  }

  async function processAccountLockAsMblFromHbl() {
    const mblId = selectedElement.oiMblId;

    const accountLockResult = await appContext.api.accountClose(
      JobNames.OIMbl,
      mblId,
      !selectedElement.isAccountClosed
    );

    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult, false, null, 'warning');
      return;
    }

    const hasOpenedMbl =
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${mblId}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/view/${mblId}`);

    const editModelKey = `editOiMbl${mblId}-/oceanImport/mbl/edit`;
    const viewModelKey = `viewOiMbl${mblId}-/oceanImport/mbl/view`;

    const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
    const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

    if (hasOpenedMbl) {
      if (selectedElement.isAccountClosed) {
        // Open
        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 0;
          fastStorage[keyMatch].isAccountClosed = false;
          fastStorage[keyMatch].accountClosedBy = '';
          fastStorage[keyMatch].accountCloseDate = null;

          fastStorage[keyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 0;
          });
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 0;
          fastStorage[viewKeyMatch].isAccountClosed = false;
          fastStorage[viewKeyMatch].accountClosedBy = '';
          fastStorage[viewKeyMatch].accountCloseDate = null;

          fastStorage[viewKeyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 0;
          });
        }
      } else {
        // Close
        const accountCloseDate = await appContext.api.getFieldValueDate({
          id: mblId,
          tableName: 'T_OIMMAIN',
          fieldName: 'F_AcctCloseDate'
        });

        if (keyMatch) {
          fastStorage[keyMatch].accountClosed = 1;
          fastStorage[keyMatch].isAccountClosed = true;
          fastStorage[keyMatch].accountClosedBy = userID;
          fastStorage[keyMatch].accountCloseDate = accountCloseDate;

          fastStorage[keyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 1;
          });
        }
        if (viewKeyMatch) {
          fastStorage[viewKeyMatch].accountClosed = 1;
          fastStorage[viewKeyMatch].isAccountClosed = true;
          fastStorage[viewKeyMatch].accountClosedBy = userID;
          fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;

          fastStorage[viewKeyMatch].hblList?.forEach((hbl: OiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
    }

    jobListContext.reloadData();
    setSavedEntityAfterClose('0', false, false, true);
  }
  
  let showFileLock = (!selectedElement?.isClosed ? fmsGlobal.CanFileLock : fmsGlobal.CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? fmsGlobal.CanAccountLock : fmsGlobal.CanAccountUnlock) && listSec?.grantEdit;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Container List', shortcut: 'F4', separator: false, hidden: !containerSec?.grantRead },
    { label: 'Go to AMS List', shortcut: 'Shift+F4', separator: false, hidden: !amsSec?.grantRead },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MBL List', shortcut: 'F6', separator: false, hidden: !mblSec?.grantRead },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow},
    { label: 'HBL Status Update', shortcut: '', separator: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !fmsGlobal.CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !fmsGlobal.CanFinalize || !listSec?.grantEdit },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="oih-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        switchToContainer();
        break;
      case 5:
        switchToAms();
        break;
      case 6:
        jobListContext.triggerTableSearch('F5');
        break;
      case 7:
        switchToMbl();
        break;
      case 8:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 9:
        copy();
        break;
      case 10:
        viewBillings();
        break;
      case 11:
        viewProfit();
        break;
      case 12:
        openBLStatus();
        break;
      case 13:
        openContainerTracking();
        break;
      case 14:
        processFileLock();
        break;
      case 15:
        processAccountLock();
        break;
      case 16:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function HblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const { copy, create, edit, view,switchToMbl, switchToContainer, switchToAms, viewBillings, moveToDeleteHistoryReport, viewProfit } = useSelectedHblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  

  const selectedElement = jobListContext.selectedElement as OiHblListItem;

  let id = selectedElement?.id??0;
  let jobName = JobNames.OIHbl;
  let listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIHbl, selectedElement?.branch);
  let infoHeadline = `HBL #: ${selectedElement?.hblNo ?? ''}`;
  const mblSec = findSecurityTask(appContext, FmsSecTask.OIMbl);

  if (selectedElement?.sbl) {
    id = selectedElement?.oiMblId??0;
    jobName = JobNames.OIMbl;
    listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.OIMbl, selectedElement?.branch);
    infoHeadline = `MBL No: ${selectedElement?.mblNo ?? ''}`;
  }

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      if (mblSec.grantRead)
        switchToMbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F4") {
      switchToContainer();
    } else if (unprocessedFkey === "SHIFT+F4") {
      switchToAms();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'SHIFT+F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={jobName}
      jobId={id}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      isDirectBl={false}
      isSingleBl={selectedElement?.sbl}
    />
  );
}


function RemarkPopup({ rowId, onClose, cell }: { rowId: any, onClose: any, cell: any }) {
  const [remark, setRemark] = useState<string | null>(cell.value ?? '');
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const setSavedEntity = useSetEditedId([JobNames.OIHbl]);

  const infoHeadline = `Remark (Ref.# ${(jobListContext.selectedElement as OiHblListItem|null)?.refNo ?? ''})`;

  function save(rowId: number, PopupInputValue: string) {
    if (cell.value !== PopupInputValue) {
      DoSave(rowId, PopupInputValue, appContext);
      onClose();
      setSavedEntity(rowId.toString(), false);
    }
    else
      onClose();
  }

  return (
    <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title={infoHeadline} width="550px">
      <div className='report-popup'>
        <div style={{ height: '200px', display: 'flex' }}>
          <div style={{ width: '480px' }}>
           <MultilineTextBox
                  name='oih-detail-remark'
                  textId="remark"
                  style={{height: '190px'}}
                  value={remark}
                  onChange={e => setRemark(e.target.value)}
                  maxLength={800}
                />

          </div>
        </div>
        <div className="report-footer" >
          <SecondaryButton size="regular" focusable={true} onClick={() => { save(rowId, remark ?? '') }}>
            SAVE
          </SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton size="regular" focusable={true} onClick={onClose}>
            CANCEL
          </SecondaryButton>
        </div>
      </div>
    </IfmsModal>
  );
}



function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for HBL List screen
 *
 * @class HblListView
 * @extends {AbstractListView}
 */
class HblListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    //return this.systemSettings?.showMilestoneInOihList ? oceanImportHblListWithMilestone : oceanImportHblList;
    const tsettings = oceanImportHblList;
    const useBranch = systemSettings?.enableBranch ?? false;
    let cols: XCol.XExportColumn[] = [];
    if (this.systemSettings?.showMilestoneInOihList) {
      cols = OiHblListItem.getExportCollection(OihListType.HblInfo, useBranch,this.systemSettings?.isCanada);
    }
    else if (this.suntekSettings?.oceanAir?.useLotNumber){
      cols = OiHblListItem.getExportCollection(OihListType.UseLot, useBranch,this.systemSettings?.isCanada);
    }
    else {
      cols = OiHblListItem.getExportCollection(OihListType.Normal, useBranch,this.systemSettings?.isCanada);
    }
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;

  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: OIShipmentTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'lclFcl',   //'containerMode',
        renderer: LclFclFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'bizMode',    //'hblType',
        renderer: HblTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'invStat',    //'inFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'billStat',   //'biFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'crDbStat',   //'crdbFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'hasCLimit',
        renderer: undefined,
        searchValueExtractor: (v:any|null|undefined) => v === true ? 'Y' : 'N',
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== null ? changeRQEvent(v): "",
      },
      // {
      //   accessor: 'amsBlNo',
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v: any | null | undefined) => v
      // },
      // {
      //   accessor: 'isfNo',
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v: any | null | undefined) => v ? 'true' : 'false'
      // },

      // { accessor: 'amsDownload', 
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' 
      // },
      // { accessor: 'customsClearance', 
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'customsHold', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'examOn', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'examOff', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'fdaHold', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'fdaRelease', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'releaseOrderRequired', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'customsRelease', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const lType = this.systemSettings?.showMilestoneInOihList ? OihListType.HblInfo : OihListType.Normal
    const useBranch = systemSettings?.enableBranch ?? false;
    
    return OiHblListItem.getExportCollection(lType, useBranch,this.systemSettings?.isCanada).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if(x.dataIndex === 'memoCnt') { colRenderer.Cell = MemoDetailRenderer;}
      else if(x.dataIndex === 'refNo') {colRenderer.Cell = RefNoRenderer;}
      else if(x.dataIndex === 'hblNo') {colRenderer.Cell = HblNoRenderer;}
      // else if (x.dataIndex === 'recognized') {
      //   colRenderer.Cell = RecognizedRenderer;
      // }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'sName' || x.dataIndex === 'cName' || x.dataIndex === 'nName' || x.dataIndex === 'bName')
        colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if (x.dataIndex === 'aName') colRenderer.Cell = AgentRenderer;
      else if (x.dataIndex === "oblStat") {
        colRenderer.Cell = OblColRenderer;
      }
      else if (x.dataIndex === "oblDate") {
        colRenderer.Cell = OblDateRenderer;
      }
      else if (x.dataIndex === "rlsStat") {
        colRenderer.Cell = RlsStatRenderer;
      }
      else if (x.dataIndex === "rlsDate") {
        colRenderer.Cell = RlsDateRenderer;
      }
      else if (x.dataIndex === "remark") {
        colRenderer.Cell = RemarkRenderer;
      }
      else if (x.dataIndex === 'lastEvent') colRenderer.Cell = TrackEventNameRenderer;
      else if (x.dataIndex === "useAmsBlNo") colRenderer.Cell = AmsRenderer;
      else if (x.dataIndex === 'useIsfNo') colRenderer.Cell = IsfRenderer;
      else if (x.dataIndex === 'chbRspCode') colRenderer.Cell = ChbRenderer;
      else if (x.dataIndex === 'payStat') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'itNo') colRenderer.Cell = InbondRenderer;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if (x.dataIndex === 'cbm')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={3} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OIHbl} />;
        colRenderer.Header =  () => <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>;
      }
      else if (x.dataIndex === 'cntrNo') colRenderer.Cell = ContainerRenderer;
      if (x.dataIndex === 'lclFcl') {
              colRenderer.Cell = LclFclRenderer;
      }
      // debugger
      return colRenderer;
    });

  }
 
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'oblDate', changedValue: (value: any)=> { return formatDate(value['oblDate'])}});
    colRenderer.push({accessor: 'rlsDate', changedValue: (value: any)=> { return formatDate(value['rlsDate'])}});
    colRenderer.push({accessor: 'lastEvent', changedValue: (value: any)=> { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '')}});
    //colRenderer.push({accessor: 'useAmsBlNo', changedValue: (value: any)=> { return value['useAmsBlNo'] ? 'checked' : ''}});
    colRenderer.push({accessor: 'useAmsBlNo', changedValue: (value: any)=> { return nullableCheckBoxValue(value['useAmsBlNo'])}});
    colRenderer.push({accessor: 'useIsfNo', changedValue: (value: any)=> { return nullableCheckBoxValue(value['useIsfNo'])}});
    colRenderer.push({accessor: 'pkgs', changedValue: (value: any)=> { return value['pkgs']}});
    colRenderer.push({accessor: 'cbm', changedValue: (value: any)=> { return Decimalformat(value['cbm'],3)}});
    colRenderer.push({accessor: 'lbs', changedValue: (value: any)=> { return Decimalformat(value['lbs'],2)}});
    colRenderer.push({accessor: 'kgs', changedValue: (value: any)=> { return Decimalformat(value['kgs'],2)}});
    colRenderer.push({accessor: 'doorMove', changedValue: (value: any)=> { return nullableCheckBoxValue(value['doorMove'])}});
    colRenderer.push({accessor: 'cClear', changedValue: (value: any)=> { return nullableCheckBoxValue(value['cClear'])}});
    colRenderer.push({accessor: 'cHold', changedValue: (value: any)=> { return nullableCheckBoxValue(value['cHold'])}});   
    colRenderer.push({accessor: 'lclFcl', changedValue: (value: any)=> { return formatLclFcl(value['lclFcl'])}});
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { return displayLastTrackingEvent(value)}});
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    //const apiResult = await api.getOceanImportHbl(search);
    const apiResult = await api.getListItems(JobNames.OIHbl, 'OiHblListItem', 
      OiHblListItem.calculateSearchParameters(search, OiHblListItem.MapSearchFields, ['shipmentType']), 
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );
      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OIHbl, 'OiHblListItem',
      OiHblListItem.calculateSearchParameters(search, OiHblListItem.MapSearchFields, ['shipmentType']), 
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }

  renderCommands(): ReactNode {
    return (
      <HblListCommands />
    );
  }

  renderBeforeConfigureButton(): ReactNode {
    return (
      <HblListToolbar />
    );
  }

  renderAfterConfigureButton(): ReactNode {
    return <></>;
  }

  renderExtras(hideLogHistory: boolean): ReactNode {
    return <HblListViewExtras hideLogHistory={hideLogHistory} />
  }

  public renderInsideTopRightOpMenu(): React.ReactNode {
    return (
      <BlackInverseButton size="large" data-tooltip="Container Tracking" >
        <ContainerTrackingIcon width={20} height={20} />
      </BlackInverseButton>
    );
  }

  getViewUrlFor(row: OiHblListItem) {
    let id = row.id;
    let url = `/oceanImport/hbl/view/${id}`;

    if (row.sbl) {
      id = row.oiMblId;
      url = `/oceanImport/mbl/view/${id}`;
    }

    return row && id ? url : '';
  }

  getListViewTitle() {
    return 'HBL List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any,  appContext: any): React.ReactNode|null {
    if (!rowId) {
      return null;
    }
    const selectedElement = context.selectedElement as OiHblListItem;

    function onClose() {
      const storageKey = `oi-hbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
      context.setmodalShow(undefined);
    }

    function onCloseHblRlsPopup() {
      const storageKey = `oih-hblrls-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
      context.setmodalShow(undefined);
    }

    const hblElement = (context.data ?? []).find(x => x.id === rowId);
    const oihSecurity = findSecurityTaskWithBranch(appContext, FmsSecTask.OIHbl, selectedElement?.branch);

    if(context.modalShow !== 'openBLStatus' && ['rlsStat', 'rlsDate'].indexOf(cell.column.dataIndex) > -1){
      return (
      <IfmsModal isBlueHeader cancelOnEsc draggable isOpen title={'Release H B/L'} onCancel={onCloseHblRlsPopup} width="900px">
        <HblReleasePopup
          hblId={rowId}
          storageKey={`oih-hblrls-${rowId}`}
          onClose={onCloseHblRlsPopup} 
          isView={false}
        />
      </IfmsModal>
      )
    }
    else if(context.modalShow !== 'openBLStatus' && ['remark'].indexOf(cell.column.dataIndex) > -1 && oihSecurity?.grantEdit){
     return (
      <RemarkPopup rowId={rowId} onClose={onClose} cell={cell} />
      );
    }
    else if(context.modalShow === 'openBLStatus')
      return (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="HBL Status Update" width="760px">
          <HblBlStatusPopup hblNo={hblElement?.hblNo ?? ''} hblId={rowId} storageKey={`oi-hbl-milestone-${rowId}`} onClose={onClose} isView={!oihSecurity?.grantEdit} />
        </IfmsModal>
      );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OIHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }
};

export default HblListView;
